import { useContext } from 'react';
import { PageContext } from './Context';

const usePage = () => {
  const { campaignName, campaignId, page } = useContext(PageContext);
  return { campaignName, campaignId, page };
};

export default usePage;